import { useQuery } from '@tanstack/react-query';
import { httpClient } from '../../services/http.client';
import { queryKeys } from '../../lib/query-keys';

export function useContracts(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.contracts.all(orgId ?? ''),
    queryFn: () => httpClient.get(`/api/v1/contracts?organization_id=${orgId}`),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}
